import { useEffect } from 'react';
import { SECOND, TEN_MINUTES_IN_MS } from 'core/common/constants';
import { useLocalStorage } from './useLocalStorage';

type CountdownProps = {
  key: string;
  duration?: number;
  stop?: number;
  enabled?: boolean;
  onFinish?: () => void;
};

export const useCountdown = ({
  key,
  duration = TEN_MINUTES_IN_MS,
  onFinish,
  stop = 0,
  enabled = true,
}: CountdownProps) => {
  const [specialPlanCountdown, setSpecialPlanCountdown] = useLocalStorage(key, duration);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    if (specialPlanCountdown <= stop) {
      if (onFinish) {
        onFinish();
      }
      return;
    }

    const timer = setTimeout(() => {
      setSpecialPlanCountdown(specialPlanCountdown - SECOND);
    }, SECOND);

    return () => {
      clearTimeout(timer);
    };
  }, [specialPlanCountdown, setSpecialPlanCountdown, onFinish, stop, enabled]);

  return { specialPlanCountdown, setSpecialPlanCountdown };
};
